// styles:
export { default as breakpoints } from "./breakpoints";
export { colors } from "./colors";
export {
    spacing,
    spacing2020WithoutBreakpoints,
    spacing2020HasBreakpoints
} from "./spacing";
export { default as fonts } from "./fonts";
export { regular, medium, bold, fontStyles } from "./fontStyles";
export { grid, containerMaxWidth } from "./widths";
export {
    easingSeconds,
    zIndexTop,
    desktopHeaderHeight,
    desktopHeaderHeightCollapsed,
    mobileHeaderHeight,
    boxShadow,
    scrollToDesktopWithHero,
    scrollToTabletWithHero,
    scrollToMobileWithHero,
    scrollToDesktopNoHero,
    scrollToMobileHeroSearchBar,
    scrollToTabletHeroSearchBar,
    scrollToDesktopHeroSearchBar,
    scrollToDesktopWithHeroLanding,
    scrollToTabletWithHeroLanding,
    scrollToMobileWithHeroLanding,
    scrollToMobileHeroLandingSearchBar,
    scrollToTabletHeroLandingSearchBar,
    scrollToDesktopHeroLandingSearchBar,
    focusBorder,
    deviceTapColor
} from "./constants";

// components:
export { Avatar } from "./avatar";
export { AvatarPlaceholderImg } from "./avatarPlaceholderImg";
export {
    Button,
    ButtonStyle,
    BlackButtonStyle,
    BlackButton,
    NewBlackButton,
    BlueButtonStyle,
    BlueButton,
    GrayButtonStyle,
    GrayButton,
    RoyalBlueButtonStyle,
    RoyalBlueButton,
    LightBlueButtonStyle,
    LightBlueButton,
    WhiteOutlineButtonStyle,
    WhiteOutlineButton,
    PillOutlineButtonStyle,
    PillOutlineButton
} from "./Button";
export { Container } from "./container";
export { Div } from "./div";
export { Grid, Row, Col } from "./grid";
export { Label } from "./label";
export { InformationalMessageBanner } from "./informationalMessageBanner"; // InformationalMessageBanner extends MessageBanner
export {
    Link,
    BaseText,
    HeaderSmall,
    textStyles,
    A,
    P,
    H1,
    H2,
    H3,
    ButtonLink,
    BorderBottomLinkStylesHover,
    BorderBottomLinkStyle,
    BorderBottomLink,
    CustomFocusStyle
} from "./Typography"; // use Heading component for headings instead of these headings

export {
    compensateForStickyHeader,
    fullWidthStyles,
    Layout,
    Section, // use SectionContainer instead
    SectionDark, // use SectionContainer instead
    SectionGray, // use SectionContainer instead
    SectionWhite, // use SectionContainer instead
    SiteContentWrapper,
    ContentShifterForStickyHeader
} from "./layout";

export { Flexbox } from "./flexbox";
export { FormFieldError } from "./formFieldError";
export { FormFieldErrorBorder } from "./formFieldErrorBorder";
export { Fieldset } from "./fieldset";
export { RadioButton } from "./radioButton";
export { Icon } from "./icon";
export {
    Card,
    CardTitle,
    CardDescription,
    CardCta,
    CardBulletList,
    CardBulletListTitle,
    CardBulletListTitleIcon,
    CardBulletListTitleContainer,
    CardHighlight,
    CardHighlightsContainer,
    CardIconContainer,
    CardMobileContentContainer,
    CardNonMobileContentContainer
} from "./card";

// To be used with Material UI grid:
export { gridThemeStyles, MaterialUIGridContainer } from "./materialUI";

// marketing page
export {
    MarketingPageSectionHeadingContainer,
    MarketingPageSectionEyebrowSubheading,
    MarketingPageSectionHeading,
    MarketingPageSectionBiLine
} from "./marketingPageSectionHeading";

export {
    Table,
    TableRow,
    TableBody,
    TableData,
    TableSubheading,
    TableColumnHeading,
    TableRowHeading,
    TableHead,
    TableColumnHighlight
} from "./table";

export {
    FeatureTableMobileColumnHeading,
    FeatureTableMobileBullet,
    FeatureTableMobileList
} from "./featureTableMobile";

export { SrOnly } from "./SrOnly"; // creates "screen reader only" visible text

/* TODO:
- need to organize styles vs shared components

- organize exports by type - all form elements together, all buttons together, etc
*/
